export const TOP_BOTTOM_PADDING = 6;
export const LEFT_RIGHT_PADDING = 9;
export const DEFAULT_FONT_SIZE = 14;
//# sourceMappingURL=variables.js.map